export default "__VITE_ASSET__CIACEakN__"